import { isEqual } from "lodash";
import { useTranslation } from "react-i18next";
import Chip from "../../Chip/Chip";
import type { MultiSelectValue } from "../MultiSelect";

interface ChipTemplateProps {
    value?: MultiSelectValue;
    selectedValues: MultiSelectValue[];
    getLabel: (item: MultiSelectValue) => string;
    onRemove: (item: MultiSelectValue) => void;
}

const ChipTemplate = (props: ChipTemplateProps) => {
    const { value, selectedValues, getLabel, onRemove } = props;
    const { t } = useTranslation("common");

    if (!value) {
        return null;
    }
    if (isEqual(value, selectedValues[0])) {
        return (
            <Chip
                label={<span className="truncate min-w-0">{getLabel(value)}</span>}
                className="w-fit max-w-64"
                pt={{ label: { className: "text-ellipsis overflow-hidden min-w-0" } }}
                onRemove={(event) => {
                    event.stopPropagation();
                    onRemove(value);
                }}
            />
        );
    }
    if (isEqual(value, selectedValues[1])) {
        return (
            <Chip
                className="ml-1.5"
                label={t("common:moreCount", { amount: selectedValues.length - 1 })}
                tooltip={selectedValues.map(getLabel).join(", ")}
            />
        );
    }
    return null;
};

export default ChipTemplate;
